export default __webpack_public_path__ + "static/media/RightBlackCircleArrow.25b29c04.svg";